import './InfoSection.scss';

import React from 'react';

import type { Nullable } from '../../../models';
import bem from '../../../utils/bem';
import type { FormatDimensionLabel } from '../types';

const [, element] = bem('info-section');

type Props = {
  mainInfo: Nullable<string>;
  formatDimensionLabels?: FormatDimensionLabel;
};

const InfoSection = ({ mainInfo, formatDimensionLabels }: Props): React.JSX.Element => {
  return (
    <div className={element('info')}>
      {formatDimensionLabels && (
        <div className={element('sub-info')} data-testid="sub-info-container">
          <div data-testid="format-info">Format: {formatDimensionLabels.format}</div>
          <div>
            {formatDimensionLabels?.dimension && (
              <p data-testid="dimensions-info">Dimensions: {formatDimensionLabels.dimension}</p>
            )}
            {formatDimensionLabels?.fileSize ? (
              <p data-testid="file-size-info" className={element('file-size-info')}>
                File Size: {formatDimensionLabels.fileSize}
              </p>
            ) : null}
          </div>
        </div>
      )}
      {mainInfo && (
        <p data-testid="main-info" className={element('main-info')}>
          {mainInfo}
        </p>
      )}
    </div>
  );
};

export default InfoSection;
